import {Component, Input, Output, EventEmitter, ViewChild, OnInit, SimpleChanges, OnChanges} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MicroSelectComponent} from "../shared/select/micro-select.component";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'micro-contactDepartment-select',
  templateUrl: './contactDepartment-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: ContactDepartmentSelectComponent
    }
  ]
})
export class ContactDepartmentSelectComponent implements OnInit, OnChanges, ControlValueAccessor {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Output()
  contactDepartmentIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Output()
  contactDepartmentChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  contactDepartmentId:any;

  @Input()
  contactCompanyId:any;

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any;

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  placeholder:string = 'Contact Department';

  options:any[];

  @Input()
  jump:boolean = true;

  onChange = (contactDepartmentId) => {};
  onTouched = () => {};
  touched = false;

  reloadDebouncer:EventEmitter<any> = new EventEmitter<any>();

  change(e) {
    this.onChange(e);
    this.contactDepartmentIdChange.emit(this.contactDepartmentId);
    this.valueChange.emit(this.sel.getSelectedValue());
    this.contactDepartmentChange.emit(this.options.find(o => o.id === e));
  }

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(contactDepartmentId: string): void {
    this.contactDepartmentId = contactDepartmentId;
  }

  reload() {
    if (!this.contactCompanyId || this.contactCompanyId.trim() === '') {
      this.options = [];
      return;
    }

    let params:HttpParams = new HttpParams()
      .set("contactCompanyId", this.contactCompanyId)
    ;

    this.sel.loading = true;
    this.http.get(`${this.env.e.url}/auth/contactDepartments/all`, {params:params}).subscribe(
      data => {
        this.options = data as any[];
        this.sel.loading = false;
      }
    );
  }

  requires() {
    if (!this.contactCompanyId || this.contactCompanyId.trim() === '') {
      this.options = [];
      return "--CONTACT COMPANY--";
    }

    return null;
  }


  ngOnInit(): void {
    this.reloadDebouncer.pipe(debounceTime(10)).subscribe(change => {
      this.reload();
    });
    this.reloadDebounced();
  }

  reloadDebounced() {
    this.reloadDebouncer.emit();
  }


  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      let change = changes[prop];
      if (prop === 'contactCompanyId' && change.currentValue !== change.previousValue) {
        this.reloadDebounced();
      }
    }
  }
}

